// I check if we are in an iframe. If in an iframe, I return true.
export function useIframeCheck() {
  return window.location !== window.parent.location;
}
